<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              <span v-if="createMode" class="mr-2">{{'Add'|translate}}</span>
              <span v-if="!createMode" class="mr-2">{{'Edit'|translate}}</span>
              {{'User'|translate}}
          </v-card-title>
          <v-card-text>
              <v-text-field :label="'Email'|translate" autofocus v-model="activeItem.email" :disabled="!$can('update','Users')"></v-text-field>
              <v-text-field :label="'User Name'|translate" autofocus v-model="activeItem.user_name" :disabled="!$can('update', 'Users')"></v-text-field>
              <v-text-field :label="'Updated On'|translate" autofocus v-model="activeItem.updated_on" disabled></v-text-field>
              <v-text-field :label="'Created On'|translate" autofocus v-model="activeItem.created_on" disabled></v-text-field>
              <v-select :items="roles"
                      :label="'Role'|translate"
                      v-model="activeItem.role"
                      :disabled="!$can('update', 'Users')"
              ></v-select>
              <v-select v-if="managedFacilities&&!facilityClusterMap" :items="managedFacilities.split(',')" v-model="activeItem.meta.authorized_facilities"
                                 chips
                                 multiple
                                 :label="'Authorized Facilities'|translate" ></v-select>
              <v-label v-if="facilityClusterMap">{{'Authorized Facilities'|translate}}</v-label>
              <v-treeview v-if="facilityClusterMap"
                  v-model="activeItem.meta.authorized_facilities"
                  :items="JSON.parse(facilityClusterMap)"
                  activatable
                  open-on-click
                  selected-color="success"
                  selectable
              >
              </v-treeview>
              <v-select v-if="managedNamespaces" :items="managedNamespaces.split(',')" v-model="activeItem.meta.authorized_namespaces"
                                 chips
                                 multiple
                                 :label="'Authorized Namespaces'|translate" ></v-select>
              <v-switch v-if="!createMode" color="success"  v-model="isChangePassword" :label="'Change password?'|translate"></v-switch>
              <v-text-field :label="'Password'|translate" v-model="activeItem.password" :type="'password'" v-if="isChangePassword||createMode"></v-text-field>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)">{{'Save'|translate}}</v-btn>
              <v-btn @click="initializeVar(true)">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putUser} from '../../helper'
  import { mapGetters } from 'vuex'

  export default {
    components: { },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null},
    },
      computed: {
          ...mapGetters([
              'managedFacilities','managedNamespaces','facilityClusterMap',
          ]),
      },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
          this.createMode = false
        } else {
            this.createMode = true
        }

      },
      value () {
        if (!this.activeItem.user_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        isChangePassword: false,
        createMode:true,
        dialog: false,
          roles:[
              {
                  text:this.$options.filters.translate('Administrator'),
                  value:'admin'
              },
              {
                  text:this.$options.filters.translate('Maintainer'),
                  value:'maintainer'
              },
              {
                  text:this.$options.filters.translate('Operator'),
                  value:'operator'
              },
              {
                  text:this.$options.filters.translate('Viewer'),
                  value:'viewer'
              }
          ],
          activeItem: {
              user_id: null,
              email: '',
              user_name: '',
              updated_on: '',
              created_on: '',
              role: '',
              password: '',
              meta: {
                  "authorized_facilities": ["ALL"],
                  "authorized_namespaces": ["ALL"],
              }

          },

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          user_id: null,
          email: '',
          user_name: '',
          updated_on:  '',
          created_on: '',
          role: '',
          password: '',
            meta:{
                "authorized_facilities": ["ALL"],
                "authorized_namespaces": ["ALL"],
            }
          }
          if(close) {
              this.dialog = false;
          }
      },
      async addRecord (close) {
        await putUser(
          {
            'user_id': this.activeItem.user_id,
            'email': this.activeItem.email,
            'user_name': this.activeItem.user_name,
            'updated_on': this.activeItem.updated_on,
            'created_on': this.activeItem.created_on,
            'meta': this.activeItem.meta,
            'role': this.activeItem.role,
            'password': (this.isChangePassword||this.createMode)?this.activeItem.password:'',
          }
        )
          this.$emit('updatedusers', this.dialog)
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'UserRecordDialog'
  }
</script>

<style scoped>

</style>
